import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

export interface TermoAdesaoTeplateDTO{
    title: string;
    intro: string;
    sections: Section[];
}

export interface Section{
    sectionTitle: string;
    paragraphs: string[];
}

@Injectable({
  providedIn: 'root'
})

export class TermoService{
    private readonly baseUrl = '/apiconnect/vt-recarga-certa/v1'

    constructor(private readonly http: HttpClient){}

    public downloadTermoPdf( companyId ) {
        return this.http.get(`${this.baseUrl}/companies/${companyId}/adherence-terms`, {
            observe: 'response',
            responseType: 'blob' as 'json'
        });
    }

     public getTermoTemplate(): Observable<TermoAdesaoTeplateDTO> {
     return this.http.get<TermoAdesaoTeplateDTO>(`${this.baseUrl}/adherence-terms`);
  }
}